import React from 'react';

type InsightView = 'ai' | 'cpg';

interface InsightToggleProps {
  activeView: InsightView;
  onToggle: (view: InsightView) => void;
}

const InsightToggle: React.FC<InsightToggleProps> = ({ activeView, onToggle }) => {
  return (
    <div className="inline-flex rounded-lg border border-gray-200 p-0.5 bg-gray-50">
      <button
        onClick={() => onToggle('ai')}
        className={`px-3 py-1 text-xs font-medium rounded-md transition-colors ${
          activeView === 'ai'
            ? 'bg-white text-gray-900 shadow-sm'
            : 'text-gray-500 hover:text-gray-700'
        }`}
      >
        AI Insights
      </button>
      <button
        onClick={() => onToggle('cpg')}
        className={`px-3 py-1 text-xs font-medium rounded-md transition-colors ${
          activeView === 'cpg'
            ? 'bg-white text-gray-900 shadow-sm'
            : 'text-gray-500 hover:text-gray-700'
        }`}
      >
        AI CPG Insights
      </button>
    </div>
  );
};

export default InsightToggle;
export type { InsightView };